import { render, staticRenderFns } from "./mtp-status-reviewed-modal.vue?vue&type=template&id=bf400d16"
import script from "./mtp-status-reviewed-modal.ts?vue&type=script&lang=ts&external"
export * from "./mtp-status-reviewed-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./mtp-status-reviewed-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf400d16')) {
      api.createRecord('bf400d16', component.options)
    } else {
      api.reload('bf400d16', component.options)
    }
    module.hot.accept("./mtp-status-reviewed-modal.vue?vue&type=template&id=bf400d16", function () {
      api.rerender('bf400d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/mtp-status-reviewed-modal/mtp-status-reviewed-modal.vue"
export default component.exports